export default {
  isImportEdit: false,

  selectedDateDisplay1: null,
  vesselNameJapaneseFlg:  true,
  selectedTaskId: null,
  selectedColumnKey: null,
  summaryDialogShowPopup: false,

  masterMap: {},
  monitorSettingMap: {},
  destinationWorkHeaders: [],
  destinationWorkTasksMap:{
    // <YYYYMMDD>: destinationWorkTasks
  },
  destinationWorkImportedTasksMap:{ // インポートされたオーダーデータを格納
    // <YYYYMMDD>: destinationWorkTasks
  },
  lastUpdatedTimeMap: {},

  destinationWorkOneTask: [],

  lastUpdatedForMasters:  -1,
  lastUpdatedForMonitors: -1,
  lastUpdatedForColumns:  -1,
  lastUpdatedForTasks:    -1,

  firestoreSubscribeList: [],
}
